import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/auth'
import { getStorage, ref, uploadBytesResumable, getDownloadURL, listAll, getMetadata } from 'firebase/storage'

// init
firebase.initializeApp({
  apiKey: 'AIzaSyA4Thcdb4D4QvRT33qGNlY8qYw_HrfG964',
  authDomain: 'rand-boats.firebaseapp.com',
  projectId: 'rand-boats',
  storageBucket: 'rand-boats.appspot.com',
  messagingSenderId: '650557369570',
  appId: '1:650557369570:web:de80f53ed1c2efaf2402bb'
})

import { getAnalytics, logEvent } from 'firebase/analytics'
const analytics = getAnalytics()
logEvent(analytics, 'live', { test: '123' })

export const firestore = firebase.firestore()
export const auth = firebase.auth()
export const storage = {
  //returns uploadtask
  //https://firebase.google.com/docs/storage/web/upload-files
  upload(file, reference) {
    return new Promise((resolve, reject) => {
      const uploadTask = uploadBytesResumable(ref(getStorage(), reference), file)
      uploadTask.on('state_changed', null, reject, () => {
        resolve(getDownloadURL(uploadTask.snapshot.ref))
      })
    })
  },
  //returns promise
  //https://firebase.google.com/docs/storage/web/download-files
  download(reference) {
    return getDownloadURL(ref(getStorage(), reference))
  },
  list(folderRef) {
    return listAll(ref(getStorage(), folderRef))
  },
  getMetadata(reference) {
    return getMetadata(reference)
  },
  getReference(reference) {
    return ref(getStorage(), reference)
  }
}
